module.exports = __webpack_public_path__ + "img/BD.05e8826e.svg";